import { SVGProps } from "react"
import { twMerge } from "tailwind-merge"

const IconFile = ({ className, ...props }: SVGProps<SVGSVGElement> & { className?: string }) => {
  return (
    <svg viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={twMerge("size-4", className)} {...props}>
      <path d="M8.5 8.21875H15.25V18.5C15.25 18.9142 14.9142 19.25 14.5 19.25H1.5C1.08579 19.25 0.75 18.9142 0.75 18.5V1.5C0.75 1.08579 1.08579 0.75 1.5 0.75H7.75V7.46875V8.21875H8.5Z" stroke="currentColor" strokeWidth="1.5" />
      <path d="M8.34375 0.75L15.25 7.65625" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  )
}

export default IconFile
